import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import {
	Panel,
	PanelHeader,
	PanelBody,
} from "./../../components/panel/panel.jsx";
import { useHistory } from "react-router-dom";
import moment from "moment";
import {
	ApiKey,
	ApiUrl,
	WebUrl,
	AccessRight,
	TransactionType,
	TransactionStatus,
	PanelType,
	LanguageKey,
	BankingChannelName,
	DEFAULT_PAGE_SIZE,
} from "../../util/Constant";

import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "../../redux/AppAction.js";
import { checkIfPermissionExist } from "../../util/PermissionChecker.js";
import ApiEngine from "../../util/ApiEngine.js";
import SweetAlert from "react-bootstrap-sweetalert";
const DepositRollover = (props)=>{
    let _history = useHistory();
    const { t, i18n } = useTranslation(LanguageKey._PRIMARY);
    const _userData = useSelector(state => state.authState.userData);
    const [rolloverData, setRolloverData] = useState([]);

    const _dispatch = useDispatch();
    let role1IsAllowed = checkIfPermissionExist(
        AccessRight._RESET_ROLLOVER_PERMISSION,
        true
      );
      const [activeFlag, setaAtiveFlag] = useState("");

    const [showConfirmation, setShowConfirmation] = useState(false);

    let _tableColumns = [
        {
            id: "id",
			Header: "",
			Footer: "",
			disableSortBy: true,
            columns: [
				{
					id: "id",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>
							{t("ID")}
						</div>
					),
					Cell: ({ row }) => {
						return <>{row.original.rolloverId}</>;
					},
					disableSortBy: true,
					style: {
						whiteSpace: "unset",
						wordBreak: "break-word",
					},
				},
			],
        },
        {
			id: "date",
			Header: "",
			Footer: "",
			disableSortBy: true,
			columns: [
				{
					id: "date",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>
							{t("DATE")+" (UTC+"+_userData.userTimeZone+")"}
						</div>
					),
					Cell: ({ row }) => {
						return <>{moment(row.original.date).format("YYYY-MM-DD HH:mm:ss")}</>;
					},
					disableSortBy: true,
					style: {
						whiteSpace: "unset",
						wordBreak: "break-word",
					},
				},
			],
		},
   //     {
			//id: "username",
			//Header: "",
			//Footer: "",
			//disableSortBy: true,
			//columns: [
			//	{
			//		id: "username",
			//		Header: () => (
			//			<div style={{ whiteSpace: "unset" }}>
			//				{t("MEMBER")} <br /> {t("USERNAME")}
			//			</div>
			//		),
			//		Cell: ({ row }) => {
			//			return <>{props.username}</>;
			//		},
			//		disableSortBy: true,
			//		style: {
			//			whiteSpace: "unset",
			//			wordBreak: "break-word",
			//		},
			//	},
			//],
			//},
			{
				id: "transactionTypeName",
				Header: "",
				Footer: "",
				disableSortBy: true,
				columns: [
					{
						id: "transactionTypeName",
						Header: () => (
							<div style={{ whiteSpace: "unset" }}>
								{t("TRANSACTION_TYPE")}
							</div>
						),
						Cell: ({ row }) => {
							return <>{t(row.original.transactionTypeName)}</>;
						},
						disableSortBy: true,
						style: {
							whiteSpace: "unset",
							wordBreak: "break-word",
						},
					},
				],
			},
        {
			id: "amount",
			Header: "",
			Footer: "",
			disableSortBy: true,
			columns: [
				{
					id: "amount",
					Header: () => (
						<div className="text-right"  style={{ whiteSpace: "unset" }}>
							{t("AMOUNT")}
						</div>
					),
					Cell: ({ row }) => {
						return <div className="text-right">{parseFloat(row.original.amount).toFixed(2)}</div>;
					},
					disableSortBy: true,
					style: {
						whiteSpace: "unset",
						wordBreak: "break-word",
					},
				},
			],
		},
        {
			id: "deposit",
			Header: () => <div className="text-center">{t("ROLLOVER")}</div>,
			Footer: "",
			disableSortBy: true,
			columns: [
				{
					id: "depositCount",
					Header: ({ column }) => {
						return <div className="text-center">{t("CRITERIA")}</div>;
					},
					Cell: ({ row }) => (
						<div className="text-center">
							{(row.original.rolloverType == 0 || row.original.rolloverType == 1) ? "x" + row.original.rolloverCriteria :
								(row.original.rolloverCriteria).toFixed(2)}
						</div>
					),				
					disableSortBy: true,
				},
				{
					id: "preRolloverBalance",
					Header: ({ column }) => {
						return <div className="text-center">{t("BEFORE")}</div>;
					},
					Cell: ({ row }) => (
						<div className="text-center">
							{(row.original.preRolloverBalance).toFixed(2)}
						</div>
					),
					disableSortBy: true,
				},
				{
					id: "postRolloverBalance",
					Header: ({ column }) => {
						return <div className="text-center">{t("AFTER")}</div>;
					},
					Cell: ({ row }) => (
						<div className="text-center">
							{(row.original.postRolloverBalance).toFixed(2)}
						</div>
					),
					disableSortBy: true,
				},
				{
					id: "depositProgress",
					Header: ({ column }) => {
						return <div className="text-right">{t("PROGRESS")}</div>;
					},
					Cell: ({ row }) => (
						<div className="text-right">
							{row.original.isLatestRecord == 1 ? (row.original.rolloverProgress).toFixed(2) : (row.original.rolloverTarget).toFixed(2)} / {(row.original.rolloverTarget).toFixed(2)}
						</div>
					),
					
					disableSortBy: true,
				},
			],
		},
        {
            id: "status",
			Header: "",
			Footer: "",
			disableSortBy: true,
            columns: [
				{
					id: "status",
					Header: () => (
						<div className="text-center"  style={{ whiteSpace: "unset" }}>
							{t("STATUS")}
						</div>
					),
					Cell: ({ row }) => {
						return(
							<div className="text-center">
                            {
                                row.original.isLatestRecord == 1 ?
                                (<span 
                                    className={row.original.rolloverProgress == row.original.rolloverTarget ? "text-approved font-bold" : "text-rejected font-bold"}
                                >
                                    {row.original.status} 
                                </span> ) :
                                <span className="text-pending font-bold">{row.original.status}</span>
                            }
                            
                            </div>
                        )
					},
					disableSortBy: true,
					style: {
						whiteSpace: "unset",
						wordBreak: "break-word",
					},
				},
			],
        },
     
        {
			id: "action",
			Header: "",
			Footer: "",
			disableSortBy: true,
            columns: [
				{
					id: "action",
					Header: () => (
						<div className="text-center"  style={{ whiteSpace: "unset" }}>
							{t("ACTION")}
						</div>
					),
					Cell: ({ row }) => {
						return(
							<div className="text-center">
                            {
								row.original.isLatestRecord && row.original.status !== "Cleared" && role1IsAllowed && 
                                (
                                    <button  className={row.original.rolloverProgress == row.original.rolloverTarget ? "btn btn-success font-bold clickable" : "btn btn-danger font-bold clickable-span"}
                                        onClick={() => { row.original.status !== "Cleared" && role1IsAllowed ? setShowConfirmation(true) && setaAtiveFlag(row.original.status) : setaAtiveFlag(row.original.status) }}
                                    >{t("RESET")}
                                    </button>
                                )
                            }
                          
                            </div>
                        )
					},
					disableSortBy: true,
					style: {
						whiteSpace: "unset",
						wordBreak: "break-word",
					},
				},
			],
			
		},
    ]

    useEffect(() => {
        getDepositRolloverData();
        console.log(props)
    }, [])


    const getDepositRolloverData = async ()=>{
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_ROLLOVER_RECORD + "?memberId=" + props.id);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setRolloverData(responseJson[ApiKey._API_DATA_KEY]);
        }
    }
    const resetRollover = async (status) => {
        if (status == "Active") {
            var responseJson =  await ApiEngine.get(ApiUrl._API_RESET_ROLLOVER_RECORD + "?memberId=" + props.id);
            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                _dispatch(showMessage(responseJson[ApiKey._API_SUCCESS_KEY], t(responseJson[ApiKey._API_MESSAGE_KEY])));
                getDepositRolloverData();
            }
            else
            {
                _dispatch(showMessage(responseJson[ApiKey._API_SUCCESS_KEY], t(responseJson[ApiKey._API_MESSAGE_KEY])));
                getDepositRolloverData();
            }
        }
    }
	return (
        <>
            {showConfirmation && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText={t("CONFIRM")}
                    cancelBtnText={t("CANCEL")}
                    confirmBtnBsStyle="danger"
                    title={t("ARE_YOU_SURE_TO_RESET_THE_ROLLOVER")}
                    onConfirm={() => {
                        resetRollover("Active");
                        setShowConfirmation(false);
                    }}
                    onCancel={() => {
                        setShowConfirmation(false);
                    }}
                >
                    {t("UNABLE_TO_REVERT")}
                </SweetAlert>
            )}
            <Panel>
                <ReactTable
                    data={rolloverData}
                    columns={_tableColumns}
                    // renderFooter={true} //turned off coz currently not using (on _tableColumns - footer: "")
                    globalFilterable={false}
                />
            </Panel>
        </>
       
    );
}

export default DepositRollover;
